<template>
<div>
  <m-a class="link link-underline-info text-decoration-none" :href="href"><slot></slot></m-a>
</div>
</template>
<script>
export default {
  name: "Bt2",
  props: {
    href: {
      default: 'https://mixitweb.com',
    },
  },
};
</script>

<style>
.link {
  position: relative;
  padding: 0.785rem 0;
}
.link-underline-info {
  color: var(--primary);
}
.link-underline-info:hover {
  color: var(--primary);
}
[class*="link-underline-"]:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3px;
  border-radius: 50rem;
  transition: all 0.2s cubic-bezier(0.77, 0, 0.2, 2.25);
}
[class*="link-underline-"]:hover:after {
  width: calc(100% + 8px);
  left: -4px;
}
.link-underline-info:after {
  background-color: var(--primary);
}
</style>